function Actions() {
	return <div id="pbj-drawer" />;
}

export default Actions;
